
import {SEARCH_FIELDS} from "app/app.types";

// requiring html templates so that hot reloading works
const template = require('./emailAutocomplete.html');
const NS = 'EmailAutocomplete'; // jshint ignore:line

export default function EmailAutocomplete() {
  return {
    bindToController: true,
    template,
    controllerAs: 'vm',
    restrict: 'E',
    scope: {
      hideProgress: '=',
      searchText: '=',
      searchByEmail: '=',
      triggerFocus: '=',
      customerSelected: '=',
      minLength: '=',
      displayErrors: '=',
      emailValidation: '=',
      minQueryToSearch: '=',
      autoCompleteDelay: '=',
      isTouched: '=',
      isNoPayment: '='
    },
    controller
  };
}


// just exported for unit tests
export function controller($scope, $q, unregister) {
  "ngInject";

  const vm = this;

  vm.SEARCH_FIELDS = SEARCH_FIELDS;

  addListeners();

  vm.$onInit = () => {
  };

  function addListeners() {
  }
}
